import type { ImageVariable } from '@carboncopyco/types';
import { TextButton } from '@carboncopyco/ui';
import { getMaxZIndex } from '@carboncopyco/utils';
import { useBoolean, useClickAway } from 'ahooks';
import { useMemo, useRef } from 'react';
import { VariablesSearchMenu } from '../VariablesSearchMenu';
import { VariablesEmptyState } from './VariablesEmptyState';

export interface ChooseVariableButtonProps {
  variables: ImageVariable[];
  onSelect: (variable: ImageVariable) => void;
}

export const ChooseVariableButton = ({
  variables,
  onSelect,
}: ChooseVariableButtonProps) => {
  const textRef = useRef();
  const menuRef = useRef();
  const [menuOpen, setMenuOpen] = useBoolean();
  useClickAway(setMenuOpen.setFalse, menuRef);

  const zIndex = useMemo(() => getMaxZIndex() + 10, []);

  const button = (
    <div
      onClick={setMenuOpen.toggle}
      ref={textRef}
    >
      <TextButton
        label="Choose Variable"
        color="text-ds-primary-300"
      />
    </div>
  );

  if (!variables.length) {
    return (
      <div ref={menuRef}>
        <VariablesEmptyState
          open={menuOpen}
          zIndex={zIndex}
          container={textRef.current}
          triggerElement={button}
        />
      </div>
    );
  }

  return (
    <div ref={menuRef}>
      <VariablesSearchMenu
        title="Replace with image variable"
        open={menuOpen}
        onSelect={(variable) => {
          onSelect(variable);
          setMenuOpen.setFalse();
        }}
        zIndex={zIndex}
        container={textRef.current}
        triggerElement={button}
        variables={variables}
      />
    </div>
  );
};
